export enum EToastMessageSeverity {
  Success = 'success',
  Info = 'info',
  Warning = 'warn',
  Error = 'error',
  Secondary = 'secondary',
  Contrast = 'contrast',
}

export enum EToastMessageOptions {
  LifeTime = 5000,
}
